import { type ForwardedRef, forwardRef } from "react";
import { PrefetchSelectedFilterCategories } from "@/store/news-feed/filters/usePrefetchSelectedFilterCategories";
import { useAnalysisParamsContext } from "@/store/news-feed/params/analysis-params.context";
import AnalysisAppliedFilters from "./AnalysisAppliedFilters";
import NewsFeedControlsMoreOptions from "./NewsFeedControlsMoreOptions";

/**
 * Control panel for the Analysis route: Applied Filters + More Options.
 * Date range is handled by AnalysisContentManagementPanel in the route layout.
 */
const AnalysisControlPanel = forwardRef<HTMLDivElement>(
  (_props, ref: ForwardedRef<HTMLDivElement>) => {
    const analysisParams = useAnalysisParamsContext();
    if (!analysisParams) return null;

    const startDate = analysisParams.startDate
      ? new Date(analysisParams.startDate)
      : undefined;
    const endDate = analysisParams.endDate
      ? new Date(analysisParams.endDate)
      : undefined;

    return (
      <div
        ref={ref}
        className="sticky top-0 z-10 bg-white grid grid-cols-[1fr_auto] items-start gap-4 overflow-x-auto overflow-y-visible py-4"
      >
        <PrefetchSelectedFilterCategories />
        <div className="col-start-1 row-start-1 min-w-0">
          <AnalysisAppliedFilters />
        </div>

        {/* More Options */}
        <div className="col-start-2 row-start-1 flex justify-end">
          <NewsFeedControlsMoreOptions
            feedId={analysisParams.feedId}
            startDate={startDate}
            endDate={endDate}
            filterDays={analysisParams.filterDays ?? undefined}
            formattedStartDate={analysisParams.startDate}
            formattedEndDate={analysisParams.endDate}
          />
        </div>
      </div>
    );
  },
);

AnalysisControlPanel.displayName = "AnalysisControlPanel";

export default AnalysisControlPanel;
